import { useSnackbar } from "notistack";
import { useMutation } from "react-query";
import { useService } from "shared/providers";
import { ExportPricesRequest } from "shared/services/custom-export-service";

export function useExportPriceSheet(signal: AbortSignal) {
  const { exportService } = useService();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<boolean, Error, ExportPricesRequest>(
    (request) =>
      exportService.exportPrices(
        request,
        signal
      ),
    {
      onSuccess: () => {
        enqueueSnackbar(`Price sheet was exported`, { variant: "success" });
      },
      onError: (Error) => {
        if (Error.message === "canceled") {
          enqueueSnackbar(`Price sheet export canceled`, { variant: "info" });
        } else {
          enqueueSnackbar(
            "There was a problem generating the price sheet export.",
            { variant: "error" }
          );
        }
      },
    }
  );

  return mutation;
}
